const MAX_ALT_LENGTH = 120

const HEADING_OR_IMAGE = /<h([1-6])\b[^>]*>([\s\S]*?)<\/h\1>|<img\b[^>]*>/gi
const ALT_ATTRIBUTE = /\salt(?:\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s>]+)))?/i
const DECODING_ATTRIBUTE = /\sdecoding\s*=/i

const decodeEntities = value =>
  value
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&quot;/gi, '"')
    .replace(/&#0?39;|&apos;/gi, "'")
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')

const toPlainText = value =>
  decodeEntities(String(value).replace(/<[^>]*>/g, ' '))
    .replace(/\s+/g, ' ')
    .trim()

const escapeAttribute = value =>
  value
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')

const truncate = value =>
  value.length > MAX_ALT_LENGTH
    ? `${value.slice(0, MAX_ALT_LENGTH - 1).trimEnd()}…`
    : value

const hasAlt = tag => {
  const match = tag.match(ALT_ATTRIBUTE)
  if (!match) {
    return false
  }
  return !!(match[1] || match[2] || match[3] || '').trim()
}

const withoutEmptyAlt = tag => tag.replace(ALT_ATTRIBUTE, '')

export const withRichContentImageAttributes = (
  html,
  {
    fallbackTitle = '',
    numberedLabel = (title, number) => `${title} ${number}`,
  } = {}
) => {
  if (!html || !html.includes('<img')) {
    return html
  }

  const fallback = toPlainText(fallbackTitle)
  let currentTitle = fallback
  let imagesInSection = 0

  return html.replace(HEADING_OR_IMAGE, match => {
    if (!match.startsWith('<img')) {
      const heading = toPlainText(match)
      if (heading) {
        currentTitle = heading
        imagesInSection = 0
      }
      return match
    }

    let tag = match
    if (!DECODING_ATTRIBUTE.test(tag)) {
      tag = tag.replace(/^<img/i, '<img decoding="async"')
    }
    if (hasAlt(tag) || !currentTitle) {
      return tag
    }

    tag = withoutEmptyAlt(tag)
    imagesInSection += 1
    const label =
      imagesInSection > 1
        ? numberedLabel(currentTitle, imagesInSection)
        : currentTitle

    return tag.replace(
      /^<img/i,
      `<img alt="${escapeAttribute(truncate(toPlainText(label)))}"`
    )
  })
}
